import type { LocationAssetsListWidgetsProps } from "./location-assets-list-widgets.type";

import WidgetsGrid from "@/components/Elements/WidgetsGrid";
import { ASSETS_STATISTICS_WIDGETS } from "@/components/ListStatistics/Assets";

const LocationAssetsListWidgets = ({
  children,
}: LocationAssetsListWidgetsProps) => {
  return (
    <WidgetsGrid
      widgets={[
        ASSETS_STATISTICS_WIDGETS.condition_rating,
        ASSETS_STATISTICS_WIDGETS.state,
        ASSETS_STATISTICS_WIDGETS.type,
      ]}
    >
      {children}
    </WidgetsGrid>
  );
};

export default LocationAssetsListWidgets;
